<!--
- 图形验证弹窗组件
- 概要：图片随机验证码生成，将验证码传回给父组件
-
- props:
- 1.confirmLabel(确认文本标签，可选)
- 2.dialogVisible(弹窗显示标识，可选)
-
- emit:
- 1.输入正确验证码,给父组件回调
- hasConfirmed()
- 2.关闭弹窗
- dialogHidden()
-
- @author Chenxb 2020-06-06 14:28:22
-->
<template>
<el-dialog
title="提示"
:append-to-body="true"
:visible.sync="dialogVisible"
@open="initDialog"
width="555px"
class="validate-dialog"

:close-on-click-modal="false"
:before-close="handleClose">
  <div class="dialog-panel">
    <slot></slot>
    <div class="row">
      <el-input type="text" placeholder="输入验证码" clearable v-model="checkCode" />
      <div class="s-canvas">
        <canvas @click='identifyCode = randomCode(4)' ref='sCanvas' :width="contentWidth" :height="contentHeight"></canvas>
      </div>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
      <el-button
       type="primary"
       @click="handleConfirm"
       class="el-button--success footer-btn"
       :loading="loadingStatus">
      {{confirmLabel}}
      </el-button>
      <el-button type="info" @click="handleClose" class="footer-btn">取 消</el-button>
    </span>
</el-dialog>
</template>

<script>
// import { sendMobileMessge } from '@/model/customer-manager-model'
export default {
  name: 'ImgValidateDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 确认按钮文本
    confirmLabel: {
      type: String,
      default: '确认变更'
    }
  },
  data () {
    return {
      // 验证码
      identifyCode: '',
      checkCode: '',
      // loading状态
      loadingStatus: false,
      fontSizeMin: 28,
      fontSizeMax: 36,
      backgroundColorMin: 180,
      backgroundColorMax: 240,
      colorMin: 50,
      colorMax: 160,
      lineColorMin: 40,
      lineColorMax: 180,
      dotColorMin: 0,
      dotColorMax: 255,
      contentWidth: 112,
      contentHeight: 32,
      isInitCanves: false
    }
  },
  watch: {
    identifyCode (newVal, oldVal) {
      this.drawPic()
    }
  },
  updated () {
    // 初始化查看canves是否已生成并挂载到ref 使用mounted无法获取ref元素
    if (this.$refs.sCanvas && !this.isInitCanves) {
      this.isInitCanves = true
      this.identifyCode = this.randomCode(4)
    }
  },
  methods: {
    initDialog () {
      this.checkCode = ''
      this.sendMsgTip = ''
      this.loadingStatus = false
    },
    randomCode (len) {
      let str = ''
      let range = len
      let arr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      for (let i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1))
        str += arr[pos]
      }
      return str
    },
    // 生成一个随机数
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 生成一个随机的颜色
    randomColor (min, max) {
      let r = this.randomNum(min, max)
      let g = this.randomNum(min, max)
      let b = this.randomNum(min, max)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    },
    drawPic () {
      let canvas = this.$refs.sCanvas
      console.log(canvas)
      if (!canvas) return
      let ctx = canvas.getContext('2d')
      // ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax) // 图形填充颜色设置
      ctx.strokeStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax) // 图形轮廓的颜色设置
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight) // 绘制一个填充的矩形 0 0 width height x起点 y起点  宽 高
      ctx.strokeRect(0, 0, this.contentWidth, this.contentHeight) // 绘制一个矩形边框 0 0 width height x起点 y起点  宽 高
      // ctx.clearRect(50,0,this.contentWidth,this.contentHeight)  //清除指定矩形区域，清除部分完全透明
      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }
      this.drawLine(ctx)
      this.drawDot(ctx)
    },
    drawText (ctx, txt, i) {
      ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax)
      ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei' // 字体大小
      ctx.textBaseline = 'alphabetic' // 基线对齐
      let x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1)) - 5
      let y = this.randomNum(this.fontSizeMax, this.contentHeight - 5) - 5
      var deg = this.randomNum(-45, 45)
      // 修改坐标原点和旋转角度
      ctx.translate(x, y) // 移动不同位置  参数偏移量
      ctx.rotate(deg * Math.PI / 180) // 旋转 参数角度
      ctx.fillText(txt, 0, 0)
      // 恢复坐标原点和旋转角度
      ctx.rotate(-deg * Math.PI / 180)
      ctx.translate(-x, -y)
    },
    drawLine (ctx) {
      // 绘制干扰线
      for (let i = 0; i < 2; i++) {
        ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax)
        ctx.beginPath() // 新建一条路径
        ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight)) // 设置起点x,y
        ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight)) // 绘制直线 x,y 一条当前位置到x,y点的直线
        ctx.stroke() // 通过线条绘制图形轮廓
        // ctx.closePath() //结束闭合路径
      }
    },
    drawDot (ctx) {
      // 绘制干扰点
      for (let i = 0; i < 50; i++) {
        ctx.fillStyle = this.randomColor(0, 255)
        ctx.beginPath()
        // 绘制圆弧或圆，x,y,radius，startAngle,endAngle,anticlockwise // x,y 圆心点，radius 半径，从startAngle开始到endAngle结束
        ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI)
        ctx.fill() // 通过填充路径的内容区域生成实心的图形。
      }
    },
    // 处理确认按钮点击事件
    handleConfirm () {
      if (this.checkCode === '') {
        this.alertCheckCodeError('请输入验证码')
        return
      }
      if (this.checkCode !== this.identifyCode) {
        this.setNewCode()
        this.alertCheckCodeError('验证码输入错误')
        return
      }
      this.loadingStatus = true
      this.$emit('hasConfirmed')
    },
    // 处理关闭弹窗点击事件
    handleClose () {
      this.$emit('dialogHidden')
    },
    setNewCode () {
      let self = this
      setTimeout(() => {
        self.identifyCode = self.randomCode(4)
        self.checkCode = ''
      }, 200)
    },
    // 验证码错误提示
    alertCheckCodeError (errorMsg) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, errorMsg)
      ]
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    }
  }
}
</script>

<style lang="scss">
.validate-dialog {
  .dialog-panel {
    text-align: center;
    .tip {
      color: $color-label;
    }
    .icon-ling {
      font-size: 20px;
    }
  }
  .row {
    display: flex;
    justify-content: space-between;
    width: 300px;
    margin: 0 auto 15px;
  }
  .s-canvas {
    cursor: pointer;
    display: inline-block;
    padding-top: 2px;
    margin-left: 10px;
  }
  .el-dialog__body {
    background: #fafdfc;
    padding-bottom: 10px;
  }
  .footer-btn {
    width: 108px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom/ImgValidateDialog.vue